import { React, useRef, useEffect, useState } from 'react';
import Fab from '@mui/material/Fab';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ClearIcon from '@mui/icons-material/Clear';
import EstimateWizard from './EstimateWizard';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import cloneDeep from 'lodash/cloneDeep';
import TokenService from '../../services/TokenService';
import { useSnackbar } from 'notistack';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import StyledCheckbox from './../StyledExtensions/StyledCheckbox';

export default function EstimateSummary(props) {
    const ref = useRef(true);
    const [containers, setContainers] = useState(props.pickupRequest.Containers !== undefined ? props.pickupRequest.Containers : []);
    const [showEstimateWizard, setShowEstimateWizard] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(true);
    const [notifyCustomerOnUpdate, setNotifyCustomerOnUpdate] = useState(false);
    const [notifyRecyclerOnUpdate, setNotifyRecyclerOnUpdate] = useState(false);
    let _density = useRef({});

    useEffect(() => {
        const firstRender = ref.current;

        if (firstRender) {
            ref.current = false;
            // console.log('First Render');
            loadDensityData();

        } else {
            // console.log('Not a first Render');
        }
    },[]);

    function isValidated() {
        let isValid = true;




        let errors = {};

        if (containers.length == 0) {
            //errors["Quantity"] = "Quantity is required.";
            isValid = false;
        }

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function loadDensityData() {
        let postData = {
            QuickAccessTag: ''
        }

        TokenService.orderServicePost(postData, 'Get_Density_Volume_Estimator_Data', '')
            .then((response) => {
                
                if (response !== null) {
                    let jsonData = JSON.parse(response.Get_Density_Volume_Estimator_DataResult.JsonData);
                    _density.GallonsPerBagSize = JSON.parse(jsonData.GallonsPerBagSize);
                    _density.ReturnablesPerGallon = JSON.parse(jsonData.ReturnablesPerGallon);
                }
                setIsLoading(false);
            })

            .catch((response) => {
                setIsLoading(false);
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function removeContainer(e, containerId) {
        let containersCopy = [];
        for (let i = 0; i < containers.length; i++) {
            if (containers[i].Id !== containerId) {
                containersCopy.push(containers[i]);
            }
        }
        setContainers(containersCopy);
    }

    function incrementQuantity(e, containerId) {
        let containersCopy = [];
        for (let i = 0; i < containers.length; i++) {
            if (containers[i].Id === containerId) {
                containers[i].quantity++;
            }
            containersCopy.push(containers[i]);
        }
        setContainers(containersCopy);
    }


    function decrementQuantity(e, containerId) {
        let containersCopy = [];
        for (let i = 0; i < containers.length; i++) {
            if (containers[i].Id === containerId) {
                if (containers[i].quantity >= 2) {
                    containers[i].quantity--;
                }
            }
            containersCopy.push(containers[i]);
        }
        setContainers(containersCopy);
    }

    function handleFullnessChanged(e, container) {
        let containersTemp = cloneDeep(containers);
        for (let i = 0; i < containersTemp.length; i++) {
            if (containersTemp[i].Id == container.Id) {
                containersTemp[i].containerFullness = parseInt(e.target.value);
                break;
            }
        }
        setContainers(containersTemp);
    }

    function getContainers() {
        if (containers.length === 0) {
            return "Click Add to choose a container";
        }
        else {
            return (
                <div style={{display:'flex', flexDirection:'column', justifyContents:'center'} }>
                    {
                        containers.map((container) => (
                            <Paper key={container.Id} className={styles.EstimateSummaryItem} style={{backgroundColor:'var(--paper-root)'} }
                                elevation={5}
                            >
                      
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button variant='outlined' sx={{ marginBottom: '15px', backgroundColor: 'var(--sipzee-red-2)' }}
                                        onClick={(e) => removeContainer(e, container.Id)}
                                        aria-label="add">
                                        Remove
                                    </Button>

                                </div>
                                {
                                    (props.onUpdated == null || container.containerType.toLowerCase().indexOf('bag') == -1) ?
                                        null :
                                        <div style={{display:'flex', justifyContent:'center'} }>
                                        <FormControl sx={{ border: '1px solid #d0d0d0', borderRadius: '4px', paddingLeft: '2px' }} size="small">

                                            <Select style={{ paddingRight: '20px', paddingLeft: '2px' }}
                                                value={container.containerFullness}
                                                onChange={(e) => handleFullnessChanged(e, container)}
                                                autoWidth
                                            >

                                                <MenuItem value={25}>25%</MenuItem>
                                                <MenuItem value={50}>50%</MenuItem>
                                                <MenuItem value={75}>75%</MenuItem>
                                                <MenuItem value={100}>100%</MenuItem>
                                            </Select>
                                            </FormControl>
                                            <div style={{alignSelf:'center', marginLeft:'5px'} }>Full</div>
                                        </div>
                                }
                                {
                                   
                                    container.summary
                                }
                                <div className={styles.EstimateSummaryItemQuantity}>
                                    <Fab size="small" sx={{ fontSize: 40, marginBottom: '15px', backgroundColor: 'var(--sipzee-yellow-2)' }}
                                        onClick={(e) => decrementQuantity(e, container.Id)}
                                        aria-label="add">
                                        <RemoveIcon sx={{ fontSize: 40 }} />
                                    </Fab>
                                    <div>
                                        <div>Quantity</div>
                                        <div>{container.quantity}</div>
                                    </div>
                                    <Fab size="small" sx={{ fontSize: 40, marginBottom: '15px', backgroundColor: 'var(--sipzee-green)' }}
                                        onClick={(e) => incrementQuantity(e, container.Id)}
                                        aria-label="add">
                                        <AddIcon sx={{ fontSize: 40 }} />
                                    </Fab>
                                </div>
                              
                            </Paper>
                        ))
                    }
                </div>
            )
        }
    }

    function getEstimatedQuantity() {
        if (containers.length > 0) {
            let count = 0;
            for (let i = 0; i < containers.length; i++) {
                if (containers[i].containerType == 'Original Package') {
                    if (containers[i].containerSize == '6 Pack') {
                        count += 6 * containers[i].quantity;
                        containers[i].returnableCount = 6;
                    }
                    else if (containers[i].containerSize == '8 Pack') {
                        count += 8 * containers[i].quantity;
                        containers[i].returnableCount = 8;
                    }
                    else if (containers[i].containerSize == '12 Pack') {
                        count += 12 * containers[i].quantity;
                        containers[i].returnableCount = 12;
                    }
                    else if (containers[i].containerSize == '15 Pack') {
                        count += 15 * containers[i].quantity;
                        containers[i].returnableCount = 15;
                    }
                    else if (containers[i].containerSize == '24 Pack') {
                        count += 24 * containers[i].quantity;
                        containers[i].returnableCount = 24;
                    }
                    else if (containers[i].containerSize == '30 Pack') {
                        count += 30 * containers[i].quantity;
                        containers[i].returnableCount = 30;
                    }
                    else if (containers[i].containerSize == 'otherpack') {
                        count += parseInt(containers[i].customPackQuantity) * containers[i].quantity;
                        containers[i].returnableCount = parseInt(containers[i].customPackQuantity);
                    }

                    
                }
                else if (containers[i].containerType == 'Custom Container') {
                    count += parseInt(containers[i].customPackQuantity) * containers[i].quantity;
                    containers[i].returnableCount = parseInt(containers[i].customPackQuantity);
                }
                else if (containers[i].containerType == 'Garbage Bag' ||
                    containers[i].containerType == 'Plastic Grocery Bag' ||
                    containers[i].containerType == 'Paper Grocery Bag') {

                    let totalDensity = 0;
                    let itemsTypeCount = 0;
                    if (containers[i].contentsBottles) {
                        // glass bottles
                        totalDensity += getReturnablesPerGallon('12_Oz_Bottles');
                        itemsTypeCount++;
                    }

                    if (containers[i].contentsCans) {
                        totalDensity += getReturnablesPerGallon('12_Oz_Cans');
                        itemsTypeCount++;
                    }

                    if (containers[i].contentsLargerCansBottles) {
                        totalDensity += getReturnablesPerGallon('Larger_Cans_&_Bottles');
                        itemsTypeCount++;
                    }

                    if (containers[i].contents2Liters) {
                        totalDensity += getReturnablesPerGallon('2_Liter_Bottles');
                        itemsTypeCount++;
                    }

                    let averageDensity = totalDensity / itemsTypeCount;
                    let gallonsOfContainer = getGallonsPerBag(containers[i].containerType, containers[i].containerSize);
                    let containerFullnessPercent = containers[i].containerFullness / 100.0;

                   // let containerCount = gallonsOfContainer * averageDensity * containerFullnessPercent * containers[i].quantity;
                    containers[i].returnableCount = Math.floor(gallonsOfContainer * averageDensity * containerFullnessPercent);
                    //Returnable_Count = Gallons_Of_Container * AverageDensity * Fullness //Final Calculation
                    count += Math.floor(containers[i].returnableCount * containers[i].quantity);
                }
            }
            return count;
        }
        else {
            return 0;
        }
    }

    function getGallonsPerBag(bagSize, containerSize) {
        let bag = '';
        if (bagSize === 'Plastic Grocery Bag') {
            bag = 'Plastic Grocery';
        }
        else if (bagSize === 'Paper Grocery Bag') {
            bag = 'Paper Grocery';
        }
        else if (containerSize === 'Small') {
            bag = 'Sml Garbage Bag';
        }
        else if (containerSize === 'Medium') {
            bag = 'Med Garbage Bag';
        }
        else if (containerSize === 'Large') {
            bag = 'Lg Garbage Bag';
        }
        else if (containerSize === 'XLarge') {
            bag = 'XLg Garbage Bag';
        }

        if (_density.GallonsPerBagSize !== undefined) {
            for (let i = 0; i < _density.GallonsPerBagSize.length; i++) {
                if (_density.GallonsPerBagSize[i].Container_Name === bag) {
                    return _density.GallonsPerBagSize[i].Volume_in_Gallons;
                }
            }
        }

        return 0;
    }

    function getReturnablesPerGallon(contentType) {
        if (_density.ReturnablesPerGallon === undefined) {
          //  loadDensityData();
        }
        else {
            for (let i = 0; i < _density.ReturnablesPerGallon.length; i++) {
                if (_density.ReturnablesPerGallon[i].ReturnableType === contentType) {
                    return _density.ReturnablesPerGallon[i].Density_per_Gallon;
                }
            }
        }

        return 0;
    }

    function estimateWizard_OnAccepted(estimate) {
        let containersCopy = containers.slice();
        estimate.Id = uuidv4();
        containersCopy.push(estimate);

        setContainers(containersCopy)
        setShowEstimateWizard(false);
    }

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    function showSkeleton() {
        return <div>Loading</div>
    }

    //let estimatedQuantity = getEstimatedQuantity();
    
    //let estimatedValuePanel = null;
    //if (estimatedQuantity > 0) {
    //    estimatedValuePanel = (<div>Estimated Count: {estimatedQuantity} </div>);
    //}


    return (
       
        
        <div>
            {
                isLoading ? showSkeleton()
                    :

                    <>
                        <div className={styles.cardHeader}>Estimate Summary</div>

                        <Fab className='pulseButton-yellow' sx={{ backgroundColor: 'var(--sipzee-yellow)', fontSize: 40, marginBottom: '15px' }}
                            onClick={() => setShowEstimateWizard(true)}
                            aria-label="add">
                            <AddIcon />
                        </Fab>

                        <div>
                            {getEstimatedQuantity() == 0 ?
                                null
                                :
                                <div>Estimated Count: {getEstimatedQuantity()} </div>
                            }
                        </div>

                        <div>{getContainers()}</div>

                        {props.showNotificationOptions === true ?
                            <div style={{ borderTop: '1px solid var(--sipzee-gray-2' }}>
                                <FormGroup>
                                    <FormControlLabel control={<StyledCheckbox checked={notifyCustomerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(!notifyCustomerOnUpdate) }} />} label="Notify Customer" />
                                    {props.pickupRequest.Status_Reason === 'Scheduled' ?
                                        <FormControlLabel control={<StyledCheckbox checked={notifyRecyclerOnUpdate} onChange={() => { setNotifyRecyclerOnUpdate(!notifyRecyclerOnUpdate) }} />} label="Notify Recyler" />
                                        :
                                        null
                                    }

                                    <FormControlLabel defaultChecked control={<StyledCheckbox checked={!notifyCustomerOnUpdate && !notifyRecyclerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(false); setNotifyRecyclerOnUpdate(false); }} />} label="Silent Update" />
                                </FormGroup>
                            </div>
                            : null
                         }

                        {props.onUpdated !== undefined ?
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                                <div style={{ display: 'flex', width: '300px', justifyContent: 'flex-end' }}>
                                    <Button onClick={props.onBack} style={{ marginRight: '2px' }}>Cancel</Button>
                                    <Button disabled={!isValidated().isValid} onClick={() => props.onUpdated(containers, getEstimatedQuantity())}>Save</Button>
                                </div>
                            </div>
                            :
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                                <div style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}>
                                    <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                                    <Button variant={isValidated().isValid ? "contained" : "outlined"} color="sipzeeGreen" disabled={!isValidated().isValid} onClick={() => props.onNext(containers, getEstimatedQuantity())}>Next <KeyboardArrowRight /></Button>
                                </div>
                            </div>
                        }


                        {showEstimateWizard ? <EstimateWizard onClose={() => setShowEstimateWizard(false)} onAccept={estimateWizard_OnAccepted} /> : null}
                    </>
            }
            </div>
        
     );
}